<template>

    <div class="flex flex-wrap">

        <textarea class="hidden" :name="inputName">{{ jsonData }}</textarea>

        <div class="flex flex-col w-full md:w-1/2 lg:w-1/3">
            <div class="border-b border-gray-300 card-header">
                <h2 class="px-10 py-6 text-2xl font-bold card-title">{{ title }}</h2>
            </div>

            <div class="flex flex-col flex-1 px-10 py-6">

                <Tree v-model="items" ref="tree" virtualization @change="updateJson">
                    <template #default="{ node, index, path, tree }">
                        <div v-if="node.children && node.children.length" 
                            class="inline-flex items-center justify-center w-5 h-5 mr-1 border cursor-pointer" @click="tree.toggleFold(node, path)"
                        >
                            {{ node.$folded ? '+' : '-' }}
                        </div>
                        <div v-else class="inline-flex w-5 mr-1"></div>

                        <!-- <span v-else>&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <input type="checkbox" v-model="stat.checked" /> -->
                        <span :class="{
                                'text-indigo-400': editingItem === node,
                                'cursor-pointer' : true
                            }" @click="itemClick(node)"
                        >
                              <i v-if="inputName === 'domotica_devices'" :class="node.type === 'group' || node.type === 'root' ? 'fas fa-folder' : 'fa fa-toggle-on'" role="presentation"></i>
                              <i v-if="inputName === 'video_streams'" :class="node.type === 'group' || node.type === 'root' ? 'fas fa-folder' : 'fas fa-video'" role="presentation"></i>

                              {{ node.name }}
                          </span>
                    </template>
                </Tree>

                <div class="pt-6 mt-auto">
                    <button type="button" class="btn btn-primary btn-sm" @click="addItem">
                        <i class="mr-2 fa fa-toggle-on"></i> Nieuw item
                    </button>
                    <button type="button" class="btn btn-warning btn-sm" @click="addGroup">
                        <i class="mr-2 fas fa-folder"></i> Nieuwe groep
                    </button>
                </div>
            </div>

        </div>

        <div class="w-full border-l md:w-1/2 lg:w-2/3">

            <div class="item-editing" v-if="editingItem && editingItem.type != 'root'">

                <div class="flex items-center mb-2">
                    <label class="w-full md:w-1/3">Naam</label>
                    <input type="text"
                           v-model="editingItem.name"
                           class="w-full border border-gray-300 rounded md:w-2/3"
                           maxlength="60"
                           @input="updateJson()"
                    />
                </div>
                <template v-if="editingItem.type === 'item' && inputName === 'domotica_devices'">

                    <div class="flex items-center mb-2">
                        <label class="w-full md:w-1/3">Read commando</label>
                        <input type="text"
                               v-model="editingItem.command_read"
                               class="w-full border border-gray-300 rounded md:w-2/3"
                               maxlength="60"
                               @input="updateJson()"
                        />
                    </div>

                    <div class="flex items-center mb-2">
                        <label class="w-full md:w-1/3">Toggle commando</label>
                        <input type="text"
                               v-model="editingItem.command_toggle"
                               class="w-full border border-gray-300 rounded md:w-2/3"
                               maxlength="60"
                               @input="updateJson()"
                        />
                    </div>

                    <div class="flex items-center mb-2 item-icons">
                        <label class="w-full md:w-1/3">Icoon</label>
                        <div class="flex flex-wrap w-full md:w-2/3">
                            <label v-for="icon in itemIcons">
                                <input type="radio" name="image" :value="icon" v-model="editingItem.image"  @change="updateJson()" />
                                <img :src="'/img/domotica-devices/' + icon + '.png'" />
                            </label>
                        </div>
                    </div>
                </template>

                <template v-if="editingItem.type === 'item' && inputName === 'video_streams'">

                    <div class="flex items-center mb-2">
                        <label class="w-full md:w-1/3">Lokale URL</label>
                        <input type="text"
                               v-model="editingItem.local_url"
                               class="w-full border border-gray-300 rounded md:w-2/3"
                               maxlength="255"
                               @input="updateJson()"
                        />
                    </div>

                    <div class="flex items-center mb-2">
                        <label class="w-full md:w-1/3">Remote URL</label>
                        <input type="text"
                               v-model="editingItem.remote_url"
                               class="w-full border border-gray-300 rounded md:w-2/3"
                               maxlength="255"
                               @input="updateJson()"
                        />
                    </div>

                    <div class="flex items-center mb-2">
                        <label class="w-full md:w-1/3">SIP</label>
                        <input type="text"
                               v-model="editingItem.sip"
                               class="w-full border border-gray-300 rounded md:w-2/3"
                               maxlength="255"
                               @input="updateJson()"
                        />
                    </div>

                </template>

                <button type="button" class="btn btn-danger btn-sm" @click="removeItem">
                    <i class="mr-2 fa fa-times"></i> Verwijder
                </button>
                <!-- <button type="button" class="btn btn-info btn-sm" @click="duplicateItem"><i class="fa fa-times"></i> dupliceren</button> -->

            </div>

        </div>

    </div>

</template>

<script>
    //import VJstree from 'vue-jstree'
    import {Draggable, Tree, Fold, getPureTreeData} from 'he-tree-vue';
    import {breadthFirstSearch} from 'tree-helper'

    export default {
        props: {
            inputName: String,
            items: Array,
            itemIcons: Array,
            title: String,
            value: String,
        },

        data: function () {
            return {
                parentItem: null,
                editingItem: null,
                editingNode: null,
                jsonData: null,
                newId: 999999999,
            }
        },

        watch: {
            items(value) {
                this.updateJson();
            }
        },

        mounted(){
            this.initEditingItem();
            this.updateJson();
        },

        methods: {

            updateJson()
            {
                this.jsonData = JSON.stringify(this.$refs['tree'].getPureTreeData());
            },

            initEditingItem() {
                this.editingItem = _.first(this.items);
            },

            itemClick(item) {
                //this.$refs['tree'].toggleActive(item, true);
                this.editingItem = item;
            },

            addItem() 
            {
                // Add new item (child of the current editing item)
                if (this.editingItem && (this.editingItem.type == 'group' || this.editingItem.type == 'root'))
                    this.editingItem.children.push({
                        name: '[nieuw item]',
                        type: 'item',
                        droppable: false,
                        draggable: true,
                        children: [],
                        id: this.newId++
                    });
                else
                    this.items[0].children.push({
                        name: '[nieuw item]',
                        type: 'item',
                        droppable: false,
                        draggable: true,
                        children: [],
                        id: this.newId++
                    });

                this.updateJson();
            },

            addGroup() {
                if (this.editingItem && (this.editingItem.type == 'group' || this.editingItem.type == 'root'))
                    this.editingItem.children.push({
                        name: '[nieuwe groep]',
                        type: 'group',
                        droppable: true,
                        draggable: true,
                        children: [],
                        id: this.newId++
                    });
                else
                    this.items[0].children.push({
                        name: '[nieuwe groep]',
                        type: 'group',
                        droppable: true,
                        draggable: true,
                        children: [],
                        id: this.newId++
                    });

                this.updateJson();
            },

            removeItem() {
                if (this.editingItem) {
                    this.removeItemById(this.items, this.editingItem.id); // Assuming `this.items` is your tree root array

                    this.initEditingItem();

                    this.updateJson();
                }
            },

            removeItemById(items, itemId) 
            {
                for (let i = 0; i < items.length; i++) {
                    if (items[i].id === itemId) {
                        // Remove the item
                        items.splice(i, 1);
                        return true; // Return true to indicate the item was found and removed
                    }

                    // If the item has children, recurse into them
                    if (items[i].children && items[i].children.length) {
                        if (this.removeItemById(items[i].children, itemId)) {
                            return true; // Item was found and removed in the subtree
                        }
                    }
                }
                return false; // Item not found in this branch
            },

            onDragEnd(node, targetTree){
                // Prevent extra items to root level.
                if(this.items.length > 1)
                    return false;
            }

        },

        components: {
            Tree: Tree.mixPlugins([Draggable, Fold])
        }
    }
</script>


<style lang="scss" scoped>
    .item-editing {
        margin: 0px; padding: 25px;

        .item-icons {
            label {
                cursor: pointer;

                img { max-width: 60px; filter: grayscale(100%); }
                input[type="radio"] {
                    display: none;

                    &:checked+img { filter: none; }
                }
            }
        }
    }
</style>

<style lang="scss">
    .he-tree{
        padding: 0px;
        width: 100%;
        font-size: 14px;

        .tree-placeholder-node-back > * {
            height: 15px;
            border: 1px dashed #0088F8;
            box-sizing: border-box;
            background: rgba(0, 136, 249, 0.09);
            color: #0088f9;
            text-align: center;
            padding: 0;
            display: flex;
            align-items: center;
        }

        .tree-node {
            @apply mb-2;

            &.active > .tree-node-inner-back { background: #e1e1e1; }

            .tree-node-inner{
                padding: 0px;
                cursor: pointer;

                .expand-collapse {
                    width: 20px;
                    display: inline-block;
                }
            }
        }
    }
</style>
